module.exports = __webpack_public_path__ + "img/logo-red-66327408.png";